import React from 'react';
import { Flex, Icon, Text, useDisclosure } from '@chakra-ui/react';
import { CheckCircle, Info, Warning, WarningOctagon } from 'phosphor-react';
import { Dialog } from '../ui';

const status = {
  info: { color: 'state.link', surface: 'state.linkSurface', icon: Info },
  success: { color: 'state.success', surface: 'state.successSurface', icon: CheckCircle },
  warning: { color: 'state.warning', surface: 'state.warningSurface', icon: Warning },
  error: {
    color: 'state.destructive',
    surface: 'state.destructiveSurface',
    icon: WarningOctagon,
  },
};

const AlertModal = ({
  alertMsg,
  msgStatus,
  closeOnOverlayClick = true,
  ButtonOpen,
  buttonOpenStyles = {},
  ConfirmButton,
  useSecondaryActions,
  isOpenSecondary,
  onCloseSecondary,
}: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const tone = status[msgStatus] ?? status.info;

  return (
    <>
      {ButtonOpen && <ButtonOpen onClick={onOpen} style={buttonOpenStyles} />}

      <Dialog
        size="md"
        closeOnEsc={closeOnOverlayClick}
        closeOnOverlayClick={closeOnOverlayClick}
        hideCloseButton={!closeOnOverlayClick}
        isOpen={useSecondaryActions ? isOpenSecondary : isOpen}
        onClose={useSecondaryActions ? onCloseSecondary : onClose}
        footer={ConfirmButton}
      >
        <Flex align="flex-start" gap="12px" pt="8px">
          {msgStatus && (
            <Flex
              w="32px"
              h="32px"
              flexShrink={0}
              align="center"
              justify="center"
              borderRadius="lg"
              bg={tone.surface}
              color={tone.color}
            >
              <Icon as={tone.icon} w="18px" h="18px" />
            </Flex>
          )}
          {typeof alertMsg === 'string' || !alertMsg ? (
            <Text fontSize="13px" lineHeight="20px" color="content.body">
              {alertMsg ?? 'Você tem certeza dessa ação?'}
            </Text>
          ) : (
            alertMsg
          )}
        </Flex>
      </Dialog>
    </>
  );
};

export default AlertModal;
